import React, { Component } from "react";
import {
  LazyLoadImage,
  LazyLoadComponent,
} from "react-lazy-load-image-component";
import { toast } from "react-toastify";
import ApiConnect from "../../../Utils/ApiConnect";
import { connect } from "react-redux";
import { addToCart } from "../../../redux/actions/Cart.Action";
import {
  NewProductList,
  NewCategory,
} from "../../../redux/actions/Product.Action";
import AddToCartModal from "../Cart/AddToCartModal";
class ProductGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      product: "",
      note: "",
      place: 0,
      qty: 1,
    };
  }

  componentDidMount() {
    ApiConnect.get(`POS/Inventory/ProductCategory`)
      .then((response) => {
        this.props.NewProductList(response.data.product);
        this.props.NewCategory(response.data.category);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleModalOpen($prd) {
    this.setState({ product: $prd });
    if (this.props.CurrentCart.length !== 0) {
      this.setState({ show: true, note: "", place: 0, qty: 1 });
    } else {
      toast.error("Please select the table", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        draggableDirection: "y",
      });
    }
  }
  handleModalClose = () => {
    this.setState({ show: false });
  };

  render() {
    const filterProducts = this.props.ProductList || [];
    return (
      <React.Fragment>
        <ul className="product row justify-content-center">
          {filterProducts.map((product, index) => (
            <LazyLoadComponent key={index}>
              <li
                onClick={() => this.handleModalOpen(product)}
                className="bg-info"
              >
                <div className="align-items-start text-center">
                  <LazyLoadImage
                    className="avatar"
                    placeholder={
                      <span className="material-icons-outlined">
                        hourglass_top
                      </span>
                    }
                    src={product.image[0]}
                  />
                </div>

                <div className="bg-info content align-self-center">
                  <span className="title">{product.name}</span>
                  <p className="price bg-secondary text-center">
                    Rs.{product.price}
                  </p>
                </div>
              </li>
            </LazyLoadComponent>
          ))}
        </ul>
        {/* {filterProducts.map((product, index) => (
          <div
            className="col-lg-3 col-md-4 col-sm-4"
            key={index}
            onClick={() => this.handleModalOpen(product)}
          >
            <div className="card bg-theme">
              <div className="card-body p-0 ">
                <div
                  style={{
                    height: "135px",
                    width: "100%",
                    overflow: "hidden",
                  }}
                  className="bg-white tex-center"
                >
                  <LazyLoadImage
                    delayTime="300"
                    className="img-fluid"
                    height="140"
                    effect="blur"
                    placeholder={<h1 className="text-center">Loading...</h1>}
                    src={product.image[0]}
                    alt={product.name}
                  />
                </div>

                <div className="p-2">
                  <strong className="fs-14">{product.name}</strong>
                  <p className="mb-0"> 
                    Rs.{product.price}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))} */}
        <AddToCartModal
          trigger={this.state.show}
          hideTrigger={this.handleModalClose}
          product={this.state.product}
        />
      </React.Fragment>
    );
  }
}

export default connect(
  (state) => ({
    ProductList: state.Products.FilterProduct,
    CurrentCart: state.Cart.CurrentCart,
  }),
  { NewProductList, NewCategory, addToCart }
)(React.memo(ProductGrid));
